export enum FormEnum {
  Ontology = 1,
  Event = 2,
  User_Rights = 3,
  Users = 4,
  Objective = 5,
  Incident_Folder = 6,
  Incident = 7,
  Injection = 8,
  Action = 9,
  Outcome = 10,
  Observation_Task = 11,
  Configuration_Change_Request = 12,
  Trouble_Ticket = 13,
  State = 14,
  Transaction = 15,
  Lill = 16,
  Technical_Support_Request = 17,
  Experimentation = 18,
  Objective_Report = 19,
  Main_Incident_List = 20,
  Objective_vs_Incident_Chart = 21,
  Registry = 22,
  Setting = 23,
  Actor_Books = 24,
  Geostrategic_Situation = 25,
  Road_To_Current_Setting = 26,
  Line_Of_Effort = 27,
  Plan_Order_Report_Process = 28,
  Decisive_Conditions = 29,
  OD_Task = 30,
  Effect = 31,
  Phase = 32,
  Turn_Chart = 33,
  Hymotse = 34,
}

export enum OMMFormEnum {
  Objective = 1,
  Objective_Report = 2,
  Flow_State = 3,
  Flow_Transaction = 4,
}

export enum OMMFormEnumES {
  Objetivo = 1,
  Informe = 2,
  Flujo = 3,
  Transacción_de_Flujo = 4,
}

export enum OMMFormEnumTR {
  Hedef = 1,
  Rapor = 2,
  Durum_Akışı = 3,
  Durum_Geçişi = 4,
}

export enum OMMFormEnumAR {
  الهدف = 1,
  تقرير = 2,
  الحالة = 3,
  المعاملة = 4,
}

export enum FMMFormEnum {
  Incident_Folder = 1,
  Incident = 2,
  Injection = 3,
  Action = 4,
  Outcome = 5,
  Observation_Task = 6,
  Flow_State = 7,
  Flow_Transaction = 8,
  Objective_vs_Incident_Chart = 9,
  Main_Incident_List = 10,
}

export enum FMMFormEnumES {
  Carpeta_de_incidencias = 1,
  Incidencia = 2,
  Inyección = 3,
  Acción = 4,
  Resultado = 5,
  Tarea_de_Observación = 6,
  Flujo = 7,
  Transacción_de_Flujo = 8,
  Gráfico_de_objetivo_vs_incidencia = 9,
  Informe_de_lista_principal_de_Incidencias = 10,
}

export enum FMMFormEnumTR {
  Ana_Olay_Klasörü = 1,
  Tali_Olaylar = 2,
  Ara_Durumlar = 3,
  Eylemler = 4,
  Beklenen_Hasılalar = 5,
  Gözlemci_Görevleri = 6,
  Durum_Akışı = 7,
  Durum_Geçişi = 8,
  Hedef_Tali_Olay_Grafiği = 9,
  AO_TO_Listesi_Raporu = 10,
}

export enum FMMFormEnumAR {
  'مجلد الحوادث' = 1,
  حادثة = 2,
  ادخال = 3,
  إجراء = 4,
  نتيجة = 5,
  'مهمة مراقبة' = 6,
  الحالة = 7,
  المعاملة = 8,
  'مخطط الهدف مقابل الحادثة' = 9,
  'تقرير قائمة الحوادث الرئيسية' = 10,
}

export enum RLSMFormEnum {
  Configuration_Change_Request = 1,
  Trouble_Ticket = 2,
  Technical_Support_Request = 3,
  Flow_State = 4,
  Flow_Transaction = 5,
}

export enum RLSMFormEnumES {
  Solicitud_de_Cambrio_de_Configuración = 1,
  Ticket_de_Incidencia = 2,
  Solicitud_de_Soporte_Técnico = 3,
  Flujo = 4,
  Transacción_de_Flujo = 5,
}

export enum RLSMFormEnumTR {
  Konfigürasyon_Değişikliği_Talebi = 1,
  Hata_Raporlama = 2,
  Teknik_Destek_Talebi = 3,
  Durum_Akışı = 4,
  Durum_Geçişi = 5,
}

export enum RLSMFormEnumAR {
  'طلب تغيير الإعدادات' = 1,
  'بطاقة المشكلة' = 2,
  'طلب دعم فني' = 3,
  الحالة = 4,
  المعاملة = 5,
}

export enum EMMFormEnum {
  Experimentation = 1,
  Hymots_e = 2,
}

export enum EMMFormEnumES {
  Experimentación = 1,
  Hymots_e = 2,
}

export enum EMMFormEnumTR {
  Deney = 1,
  Hymots_e = 2,
}

export enum EMMFormEnumAR {
  التجربة = 1,
  Hymots_e = 2,
}

export enum LILLFormEnum {
  Lesson = 1,
  Observer = 2,
  Proprietor = 3,
  Analyst = 4,
  Tasking_Authority = 5,
  Action_Body = 6,
  Flow_State = 7,
  Flow_Transaction = 8,
}

export enum LILLFormEnumES {
  Lección = 1,
  Observador = 2,
  Propietario = 3,
  Analista = 4,
  Autoridad_Asignadora = 5,
  Cuerpo_de_la_Acción = 6,
  Flujo = 7,
  Transacción_de_Flujo = 8,
}

export enum LILLFormEnumTR {
  Ders_Adı = 1,
  Gözlemci = 2,
  Sahibi = 3,
  Analiz_Eden = 4,
  Görevlendirme_Yetkilisi = 5,
  Ders_Aksiyonu = 6,
  Durum_Akışı = 7,
  Durum_Geçişi = 8,
}

export enum LILLFormEnumAR {
  'لدروس المستفادة' = 1,
  المراقب = 2,
  المالك = 3,
  المحلل = 4,
  'جهة التكليف' = 5,
  'وصف الإجراء' = 6,
  الحالة = 7,
  المعاملة = 8,
}

export enum SSMFormEnum {
  Geostrategic_Situation = 1,
  Road_To_Current_Setting = 2,
  Actor_Books = 3,
}

export enum SSMFormEnumES {
  Situación_Geostratégica = 1,
  Evolución_Hasta_El_Estado_Actual = 2,
  Libros_De_Actores = 3,
}

export enum SSMFormEnumTR {
  Jeostratejik_Durum = 1,
  Mevcut_Duruma_Geliş_Süreci = 2,
  Aktör_Kayıtları = 3,
}

export enum SSMFormEnumAR {
  'الوضع الجيوستراتيجي' = 1,
  'الطريق إلى الاعدادات' = 2,
  'كتب الممثل' = 3,
}

export enum PPMFormEnum {
  Project = 1,
  Work_Package = 2,
  Task = 3,
  Project_Input = 4,
  Kanban = 5,
  Deliverable = 6,
  Test = 7,
  Flow_State = 8,
  Flow_Transaction = 9,
}

export enum PPMFormEnumES {
  Proyectos = 1,
  Paquete_de_Trabajo = 2,
  Tarea = 3,
  Entrada_del_Proyecto = 4,
  Kanban = 5,
  Salida_del_Proyecto = 6,
  Test = 7,
  Flujo = 8,
  Transacción_de_Flujo = 9,
}

export enum PPMFormEnumTR {
  Projeler = 1,
  İş_Paketi = 2,
  Görev = 3,
  Proje_Girdisi = 4,
  Kanban = 5,
  Proje_Çıktısı = 6,
  Test = 7,
  Durum_Akışı = 8,
  Durum_Geçişi = 9,
}

export enum PPMFormEnumAR {
  المشاريع = 1,
  'حزمة العمل' = 2,
  المهمة = 3,
  'مدخلات المشروع' = 4,
  كانبان = 5,
  المخرجات = 6,
  الاختبار = 7,
  الحالة = 8,
  المعاملة = 9,
}

export enum ADMINISTRATIONFormEnum {
  Ontology = 1,
  Event = 2,
  User_Rights = 3,
  Users = 4,
  Setting = 5,
}

export enum ADMINISTRATIONFormEnumES {
  Ontologias = 1,
  Evento = 2,
  Derechos_De_Usuraio = 3,
  Usuarios = 4,
  Configuracion = 5,
}

export enum ADMINISTRATIONFormEnumTR {
  Ontolojiler = 1,
  Veritabanı = 2,
  Kullanıcı_İzinleri = 3,
  Kullanıcılar = 4,
  Senaryo_Ayarları = 5,
}

export enum ADMINISTRATIONFormEnumAR {
  'علم الوجود' = 1,
  الحدث = 2,
  'حقوق المستخدم' = 3,
  المستخدمون = 4,
  الإعدادات = 5,
}

export enum ODC2MFormEnum {
  Phase = 1,
  Line_Of_Effort = 2,
  Plan_Order_Report_Process = 3,
  Decisive_Condition = 4,
  Task = 5,
  Effect = 6,
  Wargaming_Turn_Chart = 7,
  Tasks_Effect_DC_Report = 8,
  Operational_Design_Report = 9,
  Flow_State = 10,
  Flow_Transaction = 11,
  Risk = 12,
}

export enum ODC2MFormEnumES {
  Fase = 1,
  Linea_de_Esfuerzo_Operaciones = 2,
  Plan_Order_Informe_DP = 3,
  Condiciones_Decisivas = 4,
  Tareas_Acciones = 5,
  Efectos = 6,
  Gráfico_de_Turnos_de_Wargaming = 7,
  Informe_de_Tareas_Efectos_y_Condiciones_Determinantes = 8,
  Informe_de_Diseño_Operacional = 9,
  Flujo = 10,
  Transacción_de_Flujo = 11,
  Riesgo = 12,
}

export enum ODC2MFormEnumTR {
  Faz = 1,
  Harekât_Hatları_Operasyonlar = 2,
  Plan_Emir_Rapor = 3,
  Belirleyici_Şartlar = 4,
  Görevler_Eylemler = 5,
  Etkiler = 6,
  Oturum_Çizelgesi = 7,
  Görevler_Etkiler_Belirleyici_Şartlar_Raporu = 8,
  Harekât_Tasarısı = 9,
  Durum_Akışı = 10,
  Durum_Geçişi = 11,
  Risk = 12,
}

export enum ODC2MFormEnumAR {
  المرحلة = 1,
  'مسار الجهود / العمليات' = 2,
  'الخطة / الأمر / التقرير / نقطة القرار' = 3,
  'الشروط الحاسمة' = 4,
  'المهام / الإجراءات' = 5,
  النتائج = 6,
  'مخطط أدوار ألعاب الحرب' = 7,
  'تقرير تأثيرات المهام والظروف الحاسمة' = 8,
  'تقرير التصميم التشغيلي' = 9,
  الحالة = 10,
  المعاملة = 11,
  'إدارة المخاطر' = 12,
}

export enum COAMFormEnum {
  Coa = 1,
  Sync_Matrix = 2,
  Risk = 3,
  Coa_Analysis = 4,
}

export enum COAMFormEnumES {
  Coa = 1,
  Matriz_de_Sincronización = 2,
  Riesgo = 3,
  Anâlisis_de_Coa = 4,
}

export enum COAMFormEnumTR {
  Hareket_Tarzı_Geliştirme = 1,
  Senkronizasyon_Matrisi = 2,
  Risk = 3,
  Hareket_Tarzı_Analizi = 4,
}

export enum COAMFormEnumAR {
  'تطوير خطة العمل' = 1,
  'مصفوفة التزامن' = 2,
  'إدارة المخاطر' = 3,
  'تحليل خطة العمل' = 4,
}
